// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'


import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import { useNavigate, useParams } from "react-router-dom";

import Icon from '../../../../../../components/icon';
import MsiDatagridDynamic from '../../../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../../../configs/constant';
import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import MsiDatagrid from '../../../../../../components/custom/MsiDatagridAuto';
import KainDialog from '../../../../../../components/gudang_old/kain/gr-dialog';
import DialogPilihBarang from '../../../../../../components/gudang_old/kain/gr-dialog-barang';

interface CustomProps extends NumericFormatProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name?: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(function NumericFormatCustom(
    props,
    ref
) {
    const { onChange, ...other } = props

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name ?? '',
                        value: values.value
                    }
                })
            }}
            thousandSeparator
            valueIsNumericString
        />
    )
})

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();
    const navigate = useNavigate();

    // State
    const [valGudang, setValGudang] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])
    const [valSubGudang, setValSubGudang] = useState<any>(null)
    const [listSubGudang, setListSubGudang] = useState<any[]>([])

    const [listData, setListData] = useState<any[]>([])

    const [dialogOpen, setDialogOpen] = useState(false);

    const [barang, setBarang] = useState<any>(null)
    const [namaVendor, setNamaVendor] = useState<any>(null)
    const [noPo, setNoPo] = useState<any>(null)

    const [pilihBarangOpen, setPilihBarangOpen] = useState(false);
    const [selectedBarang, setSelectedBarang] = useState<any>(null);
    const [listBarang, setListBarang] = useState<any[]>([])

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/gudang-kain/detail-gr/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const master = response.data.master[0]
                    const detail = response.data.detail
                    const barang = response.data.barang

                    setListData(detail)
                    setListBarang(barang)

                    setValueDetail(master)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getGudang = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/gudang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id === ids) {
                            setValGudang(element)
                            setValue('mmgudang_id', element.id)
                        }
                    });
                    setListGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSubGudang = (gudangId: any) => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
            .get(url, {
                params: { mmgudang_id: gudangId },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSubGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const setValueDetail = (data: any) => {
        getGudang(12510000003)
        setValue('sysdoctag_id', 12510000009)
        setValue('nomor_sj', data.nomor_sj)
        setValue('nomor_timbang', data.nomor_timbang)
        setValue('mmgudang_id', data.mmgudang_id)

        getSubGudang(data.mmgudang_id)

        setValue('tgl_kirim', data.tgl_kirim?.substring(0, 10))

        setValue('transportasi', data.transportasi)
        setValue('berat_timbang', data.berat_timbang)
        setValue('nomor_plat', data.nomor_plat)
        setValue('kurir', data.kurir)
        // setValue('accakun_id', data.accakun_id)
        setValue('keterangan', data.keterangan)
        setValue('qty', data.qty_doc)
        setValue('harga', data.harga)
        setValue('total', data.total)
        setValue('ppn', data.ppn_persen)
        setNamaVendor(data.nama_vendor)
        setNoPo(data.pbpo_id)
    }

    const handleChangeAutocomplete = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_sub_id', newValue?.id)
        setValSubGudang(newValue)
    }

    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue ? newValue.id : null)
        setValGudang(newValue.nama)
    }

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleOpenDialogPilih = () => setPilihBarangOpen(true);
    const handleCloseDialogPilih = () => setPilihBarangOpen(false);

    const handleSelectBarang = (item: any) => {
        setBarang(item.nama)
        setSelectedBarang(item);
        setPilihBarangOpen(false)
        setDialogOpen(true); // buka KainDialog
    };

    const handleSave = (qty: number, tag: string) => {
        setDialogOpen(false);

        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const send = {
            pbpr_d_id: selectedBarang.pbpr_d_id,
            pbpo_d_id: selectedBarang.id,
            mmbarang_id: selectedBarang.mmbarang_id,
            mmsatuan_id: selectedBarang.mmsatuan_id,
            mmsatuan_doc_id: selectedBarang.mmsatuan_doc_id,
            mmgudang_id: getValues('mmgudang_id'),
            mmgudang_sub_id: getValues('mmgudang_sub_id'),
            kode: selectedBarang.kode,
            nama: selectedBarang.nama,
            qty: qty,
            qty_doc: qty,
            keterangan: tag,
            konversi: selectedBarang.konversi,
            harga: selectedBarang.harga,

        }

        const url = apiUrl.apiUrl + '/mm/gudang-kain/save-detail-gr/' + id

        axios
            .post(url, send, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: true,
                        willClose: () => {
                            Swal.close();
                            getData()
                        }
                    })
                } else {
                    setDialogOpen(false);
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
        // getData()
        // TODO: panggil API atau update state
    };


    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/gudang-kain/delete-barang-gr/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    interface FormInputs {
        pmrequest_id: any
        sysdoctag_id: any
        nomor_sj: any
        mmgudang_id: any
        mmgudang_sub_id: any
        nomor_timbang: any
        tgl_kirim: any
        transportasi: any
        berat_timbang: any
        nomor_plat: any
        kurir: any
        // accakun_id: any
        keterangan: any
        qty: any
        harga: any
        total: any
        ppn: any

        nama_vendor: any
        pbpo_id: any
    }

    const defaultValues = {
        pmrequest_id: null,
        berat_timbang: 0
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        console.log(data)
        // Swal.fire({
        //     title: 'Konfirmasi',
        //     text: 'Apakah anda ingin menyimpan data ini ?',
        //     icon: 'question',
        //     showCancelButton: true,
        //     confirmButtonColor: '#337ab7',
        //     cancelButtonColor: '#ffc107',
        //     confirmButtonText: 'Simpan'
        // }).then(result => {
        //     if (result.isConfirmed) {
        //         Swal.fire({
        //             title: 'Now loading',
        //             allowEscapeKey: false,
        //             allowOutsideClick: false,
        //             didOpen: () => {
        //                 Swal.showLoading()
        //             }
        //         })


        //         const url = apiUrl.apiUrl + '/mm/gudang/edit/' + id

        //         axios
        //             .post(url, data, {
        //                 headers: { Authorization: `Bearer ${token}` }
        //             })
        //             .then(response => {
        //                 if (response.data.success) {
        //                     Swal.fire({
        //                         title: 'Pemberitahuan',
        //                         text: response.data.message,
        //                         icon: 'success',
        //                         timer: 1000,
        //                         timerProgressBar: true,
        //                         willClose: () => {
        //                             navigate('/mm/master-gudang')
        //                         }
        //                     })
        //                 } else {
        //                     Swal.fire({
        //                         title: 'Pemberitahuan',
        //                         text: response.data.message,
        //                         icon: 'error'
        //                     })
        //                 }
        //             })
        //             .catch(error => {
        //                 Swal.fire({
        //                     title: 'Pemberitahuan',
        //                     text: error.message,
        //                     icon: 'error'
        //                 })
        //             })
        //     }
        // })
    }

    const ActionButtons = ({ row, onDeletes }: {
        row: any;
        onDeletes: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Hapus Sales Order",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDeletes(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDeletes={handleDelete}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Goods Receipt
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Dokumen Penerimaan</InputLabel>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Dokumen Penerimaan'
                                                value={value || ''}
                                                readOnly
                                                onChange={e => {
                                                    const val = e.target.value
                                                    // getUserOto(val)
                                                    onChange(e)
                                                }}
                                                error={Boolean(errors.sysdoctag_id)}
                                            >
                                                <MenuItem value={12510000009}>GR - Kain</MenuItem>
                                            </Select>
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudang}
                                        options={listGudang}
                                        id='gudang'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteGudang}
                                        getOptionLabel={(option: any) => option.nama || ''}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Gudang</InputLabel>
                                    <Controller
                                        name='mmgudang_sub_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valSubGudang}
                                                options={listSubGudang}
                                                id='mmgudang_sub_id'
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                onChange={handleChangeAutocomplete}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <li key={option.id} {...props}>
                                                            {option.kode} | {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={option => option.nama}
                                                renderInput={params => (
                                                    <TextField {...params} InputLabelProps={{ shrink: true }} label='Subgudang' />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmgudang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_kirim'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='date'
                                                value={value}
                                                label='Tanggal Kirim'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl_kirim)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_kirim && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nomor_timbang'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='No. Timbang'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.nomor_timbang)}
                                            />
                                        )}
                                    />
                                    {errors.nomor_timbang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='transportasi'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='Transportasi'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.transportasi)}
                                            />
                                        )}
                                    />
                                    {errors.transportasi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nomor_sj'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='Surat Jalan'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.nomor_sj)}
                                            />
                                        )}
                                    />
                                    {errors.nomor_sj && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='berat_timbang'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='Berat Timbang'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any
                                                }}
                                                error={Boolean(errors.berat_timbang)}
                                            />
                                        )}
                                    />
                                    {errors.berat_timbang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kurir'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='Kurir'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.kurir)}
                                            />
                                        )}
                                    />
                                    {errors.kurir && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={2}
                                                label='Keterangan'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.keterangan)}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                    <CardContent>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                <CardHeader title='Detail Barang' />
                            </Box>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                                <Fab color='primary' size='medium' onClick={handleOpenDialogPilih}>
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Box>
                        </Box>
                        <MsiDatagrid array={listData} hiddenColumns={['id']} actions={actionData} />
                    </CardContent>
                </div>
            </Grid>

            <DialogPilihBarang
                open={pilihBarangOpen}
                onClose={handleCloseDialogPilih}
                data={listBarang}
                onSelect={handleSelectBarang}
            />

            <KainDialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                kain={barang}
                vendor={namaVendor}
                po={noPo}
                onSave={handleSave}
                onDelete={handleDelete}
                detail={listData}
            />
        </Grid>
    )
}
